import React from 'react';
import { string, func, bool } from 'prop-types';
import { Icon, InlineTextButton } from '..';
import classNames from 'classnames';
import { useIntl } from '../../util/reactIntl';

import css from './Slider.module.css';

export const PrevArrow = props => {
  const { className, iconClassName, onClick, disabled } = props;
  const classes = classNames(css.sliderArrow, className);
  const intl = useIntl();
  return (
    <InlineTextButton
      className={classes}
      onClick={onClick}
      disabled={disabled}
      aria-label={intl.formatMessage({ id: 'Slider.previous' })}
    >
      <span className={classNames(css.sliderArrowIcon, iconClassName)}>
        <Icon name="chevronLeft" size={16} />
      </span>
    </InlineTextButton>
  );
};

PrevArrow.defaultProps = {
  className: null,
  iconClassName: null,
  onClick: null,
  disabled: false,
};

PrevArrow.propTypes = {
  className: string,
  iconClassName: string,
  onClick: func,
  disabled: bool.isRequired,
};

export const NextArrow = props => {
  const { className, iconClassName, onClick, disabled } = props;
  const classes = classNames(css.sliderArrow, className);
  const intl = useIntl();
  return (
    <InlineTextButton
      className={classes}
      onClick={onClick}
      disabled={disabled}
      aria-label={intl.formatMessage({ id: 'Slider.next' })}
    >
      <span className={classNames(css.sliderArrowIcon, iconClassName)}>
        <Icon name="chevronRight" size={16} />
      </span>
    </InlineTextButton>
  );
};

NextArrow.defaultProps = {
  className: null,
  iconClassName: null,
  onClick: null,
  disabled: false,
};

NextArrow.propTypes = {
  className: string,
  iconClassName: string,
  onClick: func,
  disabled: bool.isRequired,
};

const Arrows = props => {
  const { className, iconClassName, onSlidePrev, onSlideNext, prevDisabled, nextDisabled } = props;
  const classes = classNames(css.sliderArrows, className);
  return (
    <div className={classes}>
      <PrevArrow iconClassName={iconClassName} onClick={onSlidePrev} disabled={prevDisabled} />
      <NextArrow iconClassName={iconClassName} onClick={onSlideNext} disabled={nextDisabled} />
    </div>
  );
};

Arrows.defaultProps = {
  className: null,
  iconClassName: null,
  onSlidePrev: null,
  onSlideNext: null,
  prevDisabled: false,
  nextDisabled: false,
};

Arrows.propTypes = {
  className: string,
  // Added to each arrow's round icon, e.g. to colour it
  iconClassName: string,
  onSlidePrev: func.isRequired,
  onSlideNext: func.isRequired,
  prevDisabled: bool,
  nextDisabled: bool,
};

export default Arrows;
